/**
 * ReferenceCard Component generates a card containing a background image, vineyard partner information
 * and product information. Content title, content text, the image and a product ID are pulled in from contentful.
 * The product ID is used to retrieve information from the Product API, which includes information about
 * pricing and the wine itself. Content text does not show in mobile view by design.
 */

import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import '../styles/index.scss';
const defaultProps = {
  contentTitle: '',
  subTitle: '',
  content: '',
  imageAlt: '',
  imageFluid: {},
  productName: '',
  contentTextStyling: 'reference-card-content-text',
  children: null,
  roundal: null,
  roundalBackgroundColour: 'red',
  roundalPosition: 'top-left',
  buttonTitle: 'Discover'
};
const ReferenceCard = _ref => {
  let {
    contentTitle,
    subTitle,
    content,
    imageAlt,
    imageFluid,
    contentTextStyling,
    productName,
    children,
    roundal,
    roundalBackgroundColour,
    roundalPosition,
    buttonTitle,
    url = "#"
  } = _ref;
  const handleClick = event => {
    if (!url || url == "#") {
      event.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "h-100 reference-card-background"
  }, /*#__PURE__*/React.createElement(BackgroundImage, {
    className: "reference-card-image",
    fluid: imageFluid,
    alt: imageAlt,
    "data-testid": "reference-card-background-image"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "reference-card-title"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    onClick: handleClick
  }, contentTitle)), /*#__PURE__*/React.createElement("p", {
    className: "reference-card-subtitle"
  }, subTitle), /*#__PURE__*/React.createElement("div", {
    className: "black-opacity"
  }), roundal && /*#__PURE__*/React.createElement("div", {
    className: `roundal ${roundalBackgroundColour} ${roundalPosition}`
  }, roundal)), /*#__PURE__*/React.createElement("div", {
    className: "reference-card-content"
  }, productName && /*#__PURE__*/React.createElement("h3", {
    className: "reference-card-content-title"
  }, productName), content && /*#__PURE__*/React.createElement("p", {
    className: contentTextStyling
  }, content), /*#__PURE__*/React.createElement("div", {
    className: "reference-card-promo"
  }, children)));
};
ReferenceCard.defaultProps = defaultProps;
export { ReferenceCard };